
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { FaExternalLinkAlt, FaTimes } from "react-icons/fa";
import activeUnderline from "../image/pic1.png";

const Navbar = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { pathname } = useLocation();

  const isActive = (routeKeys) => routeKeys.includes(pathname);


  return (
    <nav className="relative z-[1100] w-full flex justify-center items-center py-4 px-2 md:px-0 bg-transparent">
      {/* Main pill-shaped navbar */}
      <div className="w-full max-w-[90vw] flex items-center justify-between bg-white rounded-full shadow-lg px-4 md:px-10 py-3 md:py-4 border border-gray-100">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 select-none">
          <img
            src={require("../image/USA_transparent (3).png")}
            alt="Universal Science Academy Logo"
            className="h-20 w-20"
          />
          <span className="text-lg md:text-xl font-bold text-[#061c3d] tracking-tight">Universal Science Academy</span>
        </Link>

        {/* Desktop Right Navigation */}
        <div className="hidden md:flex items-center ml-auto gap-8">
          <Link to="/" className="relative text-[#061c3d] text-[17px] font-medium hover:text-[#1176c9] transition">
            Home
            {isActive(["/"]) && (
              <img
                src={activeUnderline}
                alt=""
                aria-hidden="true"
                className="absolute left-1/2 -translate-x-1/2 top-full mt-1 h-3 w-20 object-contain pointer-events-none"
              />
            )}
          </Link>
          <Link to="/timetable" className="relative text-[#061c3d] text-[17px] font-medium hover:text-[#1176c9] transition">
            Time Table
            {isActive(["/timetable", "/class"]) && (
              <img
                src={activeUnderline}
                alt=""
                aria-hidden="true"
                className="absolute left-1/2 -translate-x-1/2 top-full mt-1 h-3 w-20 object-contain pointer-events-none"
              />
            )}
          </Link>
          <Link to="/admissions" className="relative text-[#061c3d] text-[17px] font-medium hover:text-[#1176c9] transition">
            Admissions
            {isActive(["/admissions"]) && (
              <img
                src={activeUnderline}
                alt=""
                aria-hidden="true"
                className="absolute left-1/2 -translate-x-1/2 top-full mt-1 h-3 w-20 object-contain pointer-events-none"
              />
            )}
          </Link>
          <Link to="/about-us" className="relative text-[#061c3d] text-[17px] font-medium hover:text-[#1176c9] transition">
            About Us
            {isActive(["/about-us", "/about"]) && (
              <img
                src={activeUnderline}
                alt=""
                aria-hidden="true"
                className="absolute left-1/2 -translate-x-1/2 top-full mt-1 h-3 w-20 object-contain pointer-events-none"
              />
            )}
          </Link>

          <Link to="/get-in-touch" className={`flex items-center font-semibold px-7 py-3 rounded-full shadow transition ${isActive(["/get-in-touch", "/contact"]) ? "bg-[#7fb3e6] text-[#061c3d]" : "bg-[#061c3d] text-white hover:bg-[#0a2a5c]"}`}>
            Get in Touch
            <span className="ml-3 flex items-center justify-center w-8 h-8 rounded-full bg-white text-[#061c3d]">
              <FaExternalLinkAlt size={18} />
            </span>
          </Link>
        </div>

        {/* Mobile menu button */}
        <button
          className="md:hidden flex items-center justify-center w-10 h-10 rounded-full bg-[#061c3d] text-white focus:outline-none"
          onClick={() => setDrawerOpen(true)}
          aria-label="Open menu"
        >
          <FaBars size={22} />
        </button>
      </div>

      {/* Mobile Drawer */}
      <div
        className={`fixed top-0 left-0 h-full w-64 bg-white shadow-2xl z-[999] transform transition-transform duration-300 ease-in-out ${drawerOpen ? 'translate-x-0' : '-translate-x-full'}`}
        style={{ willChange: 'transform' }}
      >
        <div className="flex items-center justify-between p-4 border-b">
          <span className="flex items-center gap-2 font-bold text-lg text-[#061c3d]">
            <img
              src={require("../image/USA_transparent (2).png")}
              alt="Universal Science Academy Logo"
              className="h-8 w-8"
            />
            Universal Science Academy
          </span>
          <button onClick={() => setDrawerOpen(false)} aria-label="Close menu">
            <FaTimes size={22} className="text-[#1176c9]" />
          </button>
        </div>
        <nav className="flex flex-col gap-4 p-4">
          <Link to="/" className={`text-[17px] font-medium hover:text-[#1176c9] ${isActive(["/"]) ? "text-[#1176c9]" : "text-[#061c3d]"}`} onClick={() => setDrawerOpen(false)}>Home</Link>
          <Link to="/timetable" className={`text-[17px] font-medium hover:text-[#1176c9] ${isActive(["/timetable", "/class"]) ? "text-[#1176c9]" : "text-[#061c3d]"}`} onClick={() => setDrawerOpen(false)}>Time Table</Link>
          <Link to="/admissions" className={`text-[17px] font-medium hover:text-[#1176c9] ${isActive(["/admissions"]) ? "text-[#1176c9]" : "text-[#061c3d]"}`} onClick={() => setDrawerOpen(false)}>Admissions</Link>
          <Link to="/about-us" className={`text-[17px] font-medium hover:text-[#1176c9] ${isActive(["/about-us", "/about"]) ? "text-[#1176c9]" : "text-[#061c3d]"}`} onClick={() => setDrawerOpen(false)}>About Us</Link>
          <Link to="/get-in-touch" className={`flex items-center font-semibold px-5 py-2 rounded-full shadow transition mt-2 ${isActive(["/get-in-touch", "/contact"]) ? "bg-[#7fb3e6] text-[#061c3d]" : "bg-[#061c3d] text-white hover:bg-[#0a2a5c]"}`}>
            Get in Touch
            <span className="ml-2 flex items-center justify-center w-7 h-7 rounded-full bg-white text-[#061c3d]">
              <FaExternalLinkAlt size={16} />
            </span>
          </Link>
        </nav>
      </div>

      {/* Overlay when drawer is open */}
      {drawerOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-[998]"
          onClick={() => setDrawerOpen(false)}
        ></div>
      )}
    </nav>
  );
};

export default Navbar;
